<template>
    
</template>

<script>

export default {
    mounted() {
        const searchParams = new URLSearchParams(window.location.search);
        const code = searchParams.get('code');
        if (code) {
            this.$store.commit('loginAuthCode', {
                code: code,
            })
        }
    }
}
</script>